export default __webpack_public_path__ + "media/images/cards-stack-image-b5194659.jpg";